"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Subtitle = void 0;

var _stitches = require("../../stitches.config");

var Subtitle = (0, _stitches.styled)('div', {
  marginBottom: '10px',
  marginTop: '10px',
  textAlign: 'center'
});
exports.Subtitle = Subtitle;
var Title = (0, _stitches.styled)('div', {
  fontSize: '$xxLarge',
  fontWeight: '$semiBold',
  marginBottom: '10px',
  textAlign: 'center'
});
exports.Title = Title;